import styled from "styled-components";

type RadioButtonType = {
  disabled?: boolean;
};

export const StyledLabel = styled.label<RadioButtonType>`
  font-family: ${({ theme }) => theme.fontFamily};
  display: flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  margin: 15px 0;
  padding-left: 40px;
  color: ${({ disabled }) => (disabled ? "#a0a0a0" : "#6d6d6d")};
  pointer-events: ${({ disabled }) => disabled && "none"};
  position: relative;
`;

export const StyledCheck = styled.div<RadioButtonType>`
  display: block;
  position: absolute;
  border: ${({ disabled }) =>
    disabled ? "3px solid #a0a0a0" : "3px solid #6d6d6d"};
  border-radius: 100%;
  height: 20px;
  width: 20px;
  left: 0;
  top: 1px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: "";
    border-radius: 100%;
    height: 14px;
    width: 14px;
    top: 3px;
    left: 3px;
    transition: background-color 0.1s linear;
  }
`;

export const StyledInput = styled.input<RadioButtonType>`
  position: absolute;
  display: flex;
  visibility: hidden;

  &:checked ~ ${StyledCheck} {
    border: ${({ disabled }) =>
      disabled ? "3px solid #a0a0a0" : "3px solid #79D9D9"};
  }

  &:checked ~ ${StyledCheck}::before {
    background: ${({ disabled }) => (disabled ? "#a0a0a0" : "#79D9D9")};
  }

  &:checked ~ label {
    color: ${({ disabled }) => (disabled ? "#a0a0a0" : "#79D9D9")};
  }
`;

StyledInput.displayName = "StyledInput";
